<template>
  <el-container class="qyChatMessages" >
    <el-header class="header-style">
    <el-divider content-position="left">微信群文件发送记录</el-divider>
    <el-row class="mb-10" :gutter="10">
      <el-col :span="24">
        <el-select clearable v-model="searchArr.chat_id" filterable remote reserve-keyword placeholder="输入群名搜素" size="mini" :remote-method="searchNameremoteMethod" :loading="searchLoading" @change="handleSearchChange">
          <el-option v-for="chat in searchChatList"
          :key="chat.contact_wx_id"
          :label="chat.contact_nick_name"
          :value="chat.contact_wx_id">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchArr.message_time"
          size="mini"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleSearchChange">
        </el-date-picker>
      </el-col>
    </el-row>
  </el-header>
  <el-main class="main-style">
    <el-table height="calc(100vh - 276px)" :data="pageData" size="mini" border style="width: 100%">
      <el-table-column label='群名' prop='contact_nick_name'>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.contact_nick_name" :open-delay="500" placement="top">
            <span class="hide-style">{{ scope.row.contact_nick_name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='发送人' prop='group_user_wx_nick_name'></el-table-column>
      <el-table-column label='文件' prop='content'>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.content" placement="top">
            <span class="hide-style">{{ scope.row.content }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='发送时间' prop='message_time'></el-table-column>
      <el-table-column fixed="right" label="聊天记录" width="80">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" content="企友聊天记录" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-s-comment" @click="handleQyChatOpen(scope.row.contact_wx_id)" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
  <el-footer class="footer-style">
    <el-pagination
      background
      class="mt-10 text-r"
      layout="total, sizes, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </el-footer>

    <el-drawer
      title="聊天记录"
      :visible.sync="qyChatDrawer"
      direction="rtl"
      :before-close="handleQyChatBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <qy-group-chat :chatId="qyChatId" :chatName="qyChatName"></qy-group-chat>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import QyGroupChat from 'common/QyGroupChat'
export default {
  name: 'QyChatMessages',
  components: {
    QyGroupChat
  },
  data () {
    return {
      pageData: [],
      searchArr: {
        chat_id: '',
        message_time: ''
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30 // 每页显示条数
      },
      searchChatList: [],
      searchLoading: false,
      qyChatId: null,
      qyChatDrawer: false,
      qyChatName: ''
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {},
  methods: {
    getPageData () {
      this.$axios.get('/api/admin/qy_wx_messages?page=' + 
      this.pageOption.currentPage + 
      '&pageSize=' + this.pageOption.pageSize +
      this.searchStr)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.pageData = data.data.pageData.data
            this.pageOption.total = data.data.pageData.total
          }
        })
    },
    searchNameremoteMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchChats(query)
        }, 200)
      } else {
        this.users = []
      }
    },
    searchChats (query) {
      this.$axios.get('/api/admin/qy_wx_messages/searchChats/' + query)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.searchChatList = data.data
          }
        })
    },
    handleSearchChange (val) {
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getPageData()
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageData();
    },
    handleQyChatOpen (chatId) {
      this.qyChatDrawer = true
      setTimeout(() => {
        this.qyChatId = chatId
        this.qyChatName = ''
      })
    },
    handleQyChatBeforeClose (done) {
      this.qyChatId = null
      this.qyChatName = ''
      done()
    }
  },
  mounted () {
    this.getPageData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .qyChatMessages
    marginLeft()
    max-height: 100vh;
    .header-style
      height: 100px !important;
      padding: 0px !important;
    .main-style
      padding: 0px !important;
      // overflow-y: auto;
    .footer-style
      text-align: right;
      .el-pagination
        padding-top: 15px;
    .mt-10
      margin-top: .2rem
    .text-r
      text-align: right
    .hide-style
      display: inherit
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/pages/qykj/QyChatMessages.vue